module.exports = __webpack_public_path__ + "images/emoji/horse.e7ac547c1621dab04695.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/horse.png
// module id = To+r
// module chunks = 13